export default "__VITE_ASSET__CGbtuUk7__"